// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut, reload } from 'firebase/auth';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // Reload user to get fresh emailVerified status
                await reload(user);
                console.log('auth state', user)
                // User is signed in, fetch user details from backend
                const userDetails = await fetchUserDetails(user.email);
                if (userDetails) {
                    setCurrentUser(userDetails); // Update state with user details
                } else {
                    setCurrentUser(user);
                }
            } else {
                // User is signed out
                setCurrentUser(null);
            }
            setLoading(false);
        });
        return unsubscribe;
    }, []);

    const logout = async () => {
        try {
            await signOut(auth); // Sign out from Firebase
            setCurrentUser(null); // Update context
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    const createUserInFirestore = async (provider, uid, email, displayName, photoURL, emailVerified) => {
        try {
            let useProvider = "email"
            if (provider === "google") {
                useProvider = "google"
            }
            console.log(provider)
            const response = await fetch(`http://localhost:8000/create-user/${useProvider}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    uid,
                    email,
                    name: displayName,
                    photoURL,
                    emailVerified: emailVerified
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to create user in Firestore');
            }

            const data = await response.json();
            console.log('User created in Firestore:', data);
            return data.user
        } catch (error) {
            console.error('Error creating user in Firestore:', error);
        }
    };

    const fetchUserDetails = async (email) => {
        try {
            const response = await fetch(`http://localhost:8000/user/${email}`);
            if (!response.ok) {
                throw new Error('Failed to fetch user details');
            }
            const userData = await response.json();
            return userData; // Return the user data
        } catch (error) {
            console.error('Error fetching user details:', error);
            return null; // Return null if there's an error
        }
    };

    useEffect(() => {
        console.log('current USER>> ', currentUser)
    }, [currentUser])

    return (
        <AuthContext.Provider value={{ currentUser, loading, setCurrentUser, logout, fetchUserDetails, createUserInFirestore }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};